import {Menu, MenuItem} from "@mui/material";
import PropTypes from "prop-types";

const MenuDropdown = ({menuId, menuItems, anchorEl, handleMenuClose}) => {
    const isMenuOpen = Boolean(anchorEl);

    return <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            {menuItems.map((menuItem, index) => (
                <MenuItem key={`${menuId}-${index}`} onClick={menuItem.handleOnClick}>
                    {menuItem.icon}
                    {menuItem.text}
                </MenuItem>
        ))}
        </Menu>
};

MenuDropdown.propTypes = {
    menuId: PropTypes.string.isRequired,
    menuItems: PropTypes.arrayOf(PropTypes.shape(
        {
            handleOnClick: PropTypes.func,
            icon: PropTypes.element,
            text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
        }
    )).isRequired,
};

export default MenuDropdown;